export const WEATHER_REPORT_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/weatherReport_v1.0.3.schema.json';
export const WEATHER_REPORT_COMPONENT_TYPE = 'WeatherReport' as const;
